<script setup>

import PanelRedimensionnable from '@/components/generiques/PanelRedimensionnable.vue';
import PanelJeuDonnees from './PanelJeuDonnees.vue'
import PanelValeur from './PanelValeur.vue'

defineProps({
  donnees: Object
})

</script>

<template>
	<PanelRedimensionnable class="panel-droit panel-lateral" :position="'droite'" :largeurIni="250">
		<PanelJeuDonnees 
			:donnees="donnees" />
		<PanelValeur />
	</PanelRedimensionnable>
</template>

<style scoped>

.panel-droit {
	padding: 2px 6px;
	flex-grow: 0;
}

</style>